// extracted by mini-css-extract-plugin
export default {"heroContainer":"FixDeafAccessPage_heroContainer__ANzco","hero":"FixDeafAccessPage_hero__EHwWJ","heroHand":"FixDeafAccessPage_heroHand__kL7ba"};